var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wpcal_admin_end",attrs:{"id":"wpcal_admin_other_app"}},[_c(_vm.dynamic_component,{tag:"component",on:{"change-dynamic-component":function($event){return _vm.load_component($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }